module.exports = __webpack_public_path__ + "img/_0.f540f346.png";